var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "final-footer", dir: "ltr" } }, [
    _vm.isOzaria && _vm.darkMode
      ? _c("img", {
          attrs: {
            src: "/images/ozaria/home/ozaria-wordmark-500px.png",
            alt: "Ozaria logo",
          },
        })
      : _vm.isOzaria && !_vm.darkMode
      ? _c("img", {
          attrs: {
            src: "/images/ozaria/home/ozaria_logo_sun.png",
            alt: "Ozaria logo",
          },
        })
      : _c("picture", [
          _c("source", {
            attrs: {
              srcset: "/images/pages/base/logo.webp",
              type: "image/webp",
            },
          }),
          _c("img", {
            attrs: {
              src: "/images/pages/base/logo.png",
              alt: "CodeCombat logo",
            },
          }),
        ]),
    _c(
      "div",
      { staticClass: "social-links" },
      _vm._l(_vm.socialLinks, function (socialLink) {
        return _c(
          "a",
          {
            key: socialLink.href,
            attrs: {
              href: socialLink.href,
              alt: socialLink.alt,
              target: "_blank",
            },
          },
          [
            _c(
              "div",
              { staticClass: "img" },
              [_c(socialLink.component, { tag: "component" })],
              1
            ),
          ]
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "copyright" },
      [
        _vm.me.showChinaResourceInfo()
          ? _c("span", { staticClass: "contact" }, [
              _vm._v(_vm._s("商务合作：" + _vm.COCO_CHINA_CONST.CONTACT_EMAIL)),
            ])
          : _vm._e(),
        _c("span", [_vm._v(_vm._s(_vm.$t("nav.copyright_prefix")))]),
        _c("span", [_vm._v(_vm._s(" ©2024 CodeCombat Inc. "))]),
        _c("span", [_vm._v(_vm._s(_vm.$t("nav.copyright_suffix")))]),
        _vm.me.showChinaResourceInfo()
          ? [
              _vm.me.showChinaHomeVersion()
                ? _c(
                    "a",
                    {
                      staticClass: "small",
                      attrs: { href: "http://beian.miit.gov.cn/" },
                    },
                    [_vm._v("京ICP备19012263号-20")]
                  )
                : _c(
                    "a",
                    {
                      staticClass: "small",
                      attrs: { href: "http://beian.miit.gov.cn/" },
                    },
                    [_vm._v("京ICP备19012263号")]
                  ),
              !_vm.me.showChinaHomeVersion()
                ? _c(
                    "a",
                    {
                      staticClass: "small",
                      attrs: {
                        href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802031936",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          id: "mps",
                          src: "/images/pages/base/the_ministry_of_public_security_of_china.png",
                        },
                      }),
                      _c("span", [
                        _vm._v(_vm._s("京公网安备 11010802031936号")),
                      ]),
                    ]
                  )
                : _c(
                    "a",
                    {
                      staticClass: "small",
                      attrs: {
                        href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038619",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          id: "mps",
                          src: "/images/pages/base/the_ministry_of_public_security_of_china.png",
                        },
                      }),
                      _c("span", [
                        _vm._v(_vm._s("京公网安备 11010802038619号")),
                      ]),
                    ]
                  ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }